import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sanitizeHtml',
  standalone: true
})
export class SanitizeHtmlPipe implements PipeTransform {
  transform(value: string): string {
    if (!value) {
      return '';
    }

    const parser = new DOMParser();
    const doc = parser.parseFromString(value, 'text/html');

    doc.querySelectorAll('p[dir="ltr"]').forEach((node) => {
      const parent = node.parentNode;
      if (parent) {
        while (node.firstChild) {
          parent.insertBefore(node.firstChild, node);
        }
        parent.removeChild(node);
      }
    });

    return doc.body.innerHTML;
  }
}

